import Loader from 'components/Loader';
import styled from 'styled-components';

const PageLoaderWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 90vh;
`;

const VisuallyHidden = styled.span`
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
`;

const PageLoader = () => {
  return (
    <PageLoaderWrapper role="status" aria-live="polite">
      <Loader />
      <VisuallyHidden>Loading…</VisuallyHidden>
    </PageLoaderWrapper>
  );
};

export default PageLoader;
